/** Attendance status values */
export const ATTENDANCE_STATUS = {
  PRESENT: 'PRESENT',
  ABSENT: 'ABSENT',
  HALF_DAY: 'HALF_DAY',
  LEAVE: 'LEAVE',
  HOLIDAY: 'HOLIDAY',
  WEEKEND: 'WEEKEND',
};

/** Attendance methods */
export const ATTENDANCE_METHOD = {
  MANUAL: 'MANUAL',
  GPS: 'GPS',
  SELFIE: 'SELFIE',
  QR: 'QR',
  LENS: 'LENS',
  BIOMETRIC: 'BIOMETRIC',
};

/** Employment types */
export const EMPLOYMENT_TYPE = {
  FULL_TIME: 'FULL_TIME',
  PART_TIME: 'PART_TIME',
  CONTRACT: 'CONTRACT',
  DAILY_WAGE: 'DAILY_WAGE',
};

/** Leave request statuses */
export const LEAVE_STATUS = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  CANCELLED: 'CANCELLED',
};

/** Payroll run statuses */
export const PAYROLL_STATUS = {
  DRAFT: 'DRAFT',
  PROCESSING: 'PROCESSING',
  APPROVED: 'APPROVED',
  PAID: 'PAID',
  FAILED: 'FAILED',
};

/** Subscription plans */
export const PLAN = {
  BASIC: 'BASIC',
  PRO: 'PRO',
  CUSTOM: 'CUSTOM',
};

/** Indian states for PT slab lookup (ISO 3166-2:IN codes) */
export const INDIAN_STATES = [
  { code: 'MH', name: 'Maharashtra' },
  { code: 'KA', name: 'Karnataka' },
  { code: 'TN', name: 'Tamil Nadu' },
  { code: 'WB', name: 'West Bengal' },
  { code: 'GJ', name: 'Gujarat' },
  { code: 'AP', name: 'Andhra Pradesh' },
  { code: 'TS', name: 'Telangana' },
  { code: 'KL', name: 'Kerala' },
  { code: 'MP', name: 'Madhya Pradesh' },
  { code: 'RJ', name: 'Rajasthan' },
  { code: 'UP', name: 'Uttar Pradesh' },
  { code: 'HR', name: 'Haryana' },
  { code: 'PB', name: 'Punjab' },
  { code: 'DL', name: 'Delhi' },
  { code: 'OR', name: 'Odisha' },
  { code: 'AS', name: 'Assam' },
];

/** Employee code prefix pattern: ORG-YYYY-NNNNN */
export const EMPLOYEE_CODE_PATTERN = /^[A-Z0-9]+-\d{4}-\d{5}$/;

/** Minimum age for employment (18 years) */
export const MIN_EMPLOYMENT_AGE = 18;

/** ESIC gross salary threshold (auto-applies if gross ≤ this) */
export const ESIC_GROSS_THRESHOLD = 21000;

/** PF Basic salary cap for 12% contribution */
export const PF_BASIC_CAP = 15000;

/** Default conveyance allowance per month */
export const DEFAULT_CONVEYANCE = 1600;

/** Default medical allowance per month */
export const DEFAULT_MEDICAL = 1250;
